<template>
  <div>
    <block-content :blocks="blocks"/>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import user from '@/components/user';
  import BlockContent from './BlockContent';

  export default {
    name: 'UserBasedContent',
    props: [
      'approved',
      'unapproved',
      'anon'
    ],
    computed: {
      ...mapState(user.store.namespace, [
          'currentUser'
      ]),
      blocks,
    },
    components: {
      BlockContent
    },
  }

  function blocks() {
    if (!this.currentUser || !this.currentUser.id) {
      return this.anon;
    } else if (this.currentUser.approved) {
      return this.approved;
    } else {
      return this.unapproved;
    }
  }
</script>

